/* eslint-disable */
import { getUser } from '../api.js'
import { default as auth0User } from '../auth0/user.js'
import notifications from '../notifications.js'

import capability from './capability.js'
import view from './view.js'

var _vars = {
  auth0PrepareApiPromise: undefined,
  userPromise: undefined,
  moduleLoading: undefined,
}

class User {
  constructor(userData) {
    this.userData = userData
    this.capabilities = undefined
    this.view = {}
  }

  setCapabilitiesAndView(capabilities, view) {
    this.capabilities = capabilities
    this.view = view
  }

  can(capabilityKey, options = {}) {
    if (this.capabilities === undefined) return false

    return this.capabilities.checkPermission(capabilityKey, options)
  }

  getUserId() {
    return this.userData.user_id
  }

  getView() {
    return this.view
  }

  getCapability(capabilityKey) {
    return this.capabilities.get(capabilityKey)
  }

  getFirstName() {
    return this.userData.first_name
  }

  getLastName() {
    return this.userData.last_name
  }

  async updateView(newView, options = {}) {
    for (const key in newView.viewRef) {
      if (newView.viewRef[key].length === 0) {
        delete newView.viewRef[key]
      }
    }
    let success = await this.view.update(newView, this.getUserId())
    return success
  }

  getConfig(configKey) {
    return this.userData.configMap[configKey]
  }
}


function setUpUser(isAuthenticated) {
  if (isAuthenticated) {
    _vars.userPromise = getUser()
      .then(response => {
        if (response.status !== 200) {
          throw new Error('unable to load user')
        }
        setSelfReady()
        let userObj = new User(response.data)
        userObj.setCapabilitiesAndView(
          capability.populate(response.data.capabilities),
          view.populate(response.data.view)
        )

        if (window.newrelic) {
          // New Relic attributes that will be attached to all logs and errors
          if (response.data.user_id) {
            window.newrelic.setUserId(String(response.data.user_id))
          }
          if (response.data.view) {
            Object.entries(response.data.view).forEach(([key, value]) => {
              window.newrelic.setCustomAttribute(`view.${key}`, JSON.stringify(value))
            });
          }
          if (response.data.configMap) {
            Object.entries(response.data.configMap).forEach(([key, value]) => {
              window.newrelic.setCustomAttribute(`config.${key}`, JSON.stringify(value))
            });
          }
        }

        return userObj
      })
      .catch(error => {
        console.error(error)
        let errorMessage = 'Network Problem: Unable to load user information.'
        if (auth0User.isEnabled()) {
          errorMessage += ' Redirecting to login page.'
          setTimeout(() => {
            auth0User.forceRelogin()
          }, 3000)
        }
        notifications.pushError(errorMessage, error)
        _vars.userPromise = undefined
      })
  }
  else {
    _vars.userPromise = Promise.resolve(
      new User({
        "first_name": undefined,
        "last_name": undefined,
        "email": undefined,
        "user_id": 0,
      })
    )
  }
  return _vars.userPromise
}


function get() {
  if (!_vars.userPromise) {
    if (!_vars.auth0PrepareApiPromise) {
      if (auth0User.isEnabled()) {
        _vars.auth0PrepareApiPromise = auth0User.isAuthenticated().then(isAuthenticated => {
          return setUpUser(isAuthenticated)
        })
      }
      else {
        _vars.auth0PrepareApiPromise = Promise.resolve(
          setUpUser(true)
        )
      }
    }
    capability.apiLock(true)
    view.apiLock(true)
    return _vars.auth0PrepareApiPromise
  }
  return _vars.userPromise
}

function setSelfReady() {
  if (_vars.moduleLoading) {
    _vars.moduleLoading.ready = true
    _vars.moduleLoading.resolve()
  }
  else {
    _vars.moduleLoading = {
      ready: true,
    }
  }
}

function ready() {
  if (_vars.moduleLoading === undefined) {
    let promise = new Promise((resolve) => {
      _vars.moduleLoading = {
        ready: false,
        resolve: resolve,
        promise: undefined,
      }
    })
    _vars.moduleLoading.promise = promise
    return promise
  }
  else if (_vars.moduleLoading) {
    if (_vars.moduleLoading.ready) {
      return Promise.resolve()
    }
    else {
      return _vars.moduleLoading.promise
    }
  }
}

export default {
  get,
  ready,
}
